import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import alert from './modules/alert'

Vue.use(Vuex)

const state = {
  isExpandLeftMenu: null,
}

const getters = {
  isExpandLeftMenu: state => state.isExpandLeftMenu,
}

const actions = {
  expandLeftMenu(context) {
    context.commit('expandLeftMenu')
  }
}

const mutations = {
  expandLeftMenu(state, value) {
    state.isExpandLeftMenu = value
  }
}

export default new Vuex.Store({
  modules: {
    auth,
    alert
  },
  state,
  getters,
  actions,
  mutations
})